import toInt from './to-int'

export const hoursAndMinutesToHoursDecimal = (hours, minutes) => {
  const totalMins = toInt(hours * 60) + toInt(minutes)
  const calcHours = totalMins / 60
  return calcHours
}
